import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { setVal2Token, getval2Token, getUserInfoCompanyId } from '../../../Login/Auth';
import { uuid, getOnlyDate } from '../../../../item/ItemTools';
import { SingleSelect, SELECT_VAL_TYPE_INT } from '../../Res/BaseInput';
import { INSURANCE_TYPE_ENROLL_3IN1, InsuranceEnrollType_Arr, ReqInsuranceList, RespInsuranceListItem, INSURANCE_TYPE_ENROLL_2IN1, INSURANCE_STATUS_ENROLL, InsuranceCombinationInitInit, INSURANCE_TYPE_ENROLL_HEALTH, INSURANCE_TYPE_ENROLL_GROUP, InsuranceCancelType_Arr, INSURANCE_STATUS_DEFAULT, INSURANCE_TYPE_CANCEL_3IN1, INSURANCE_TYPE_CANCEL_2IN1, INSURANCE_TYPE_CANCEL_HEALTH, INSURANCE_TYPE_CANCEL_GROUP, INSURANCE_STATUS_CANCEL } from '../../../../item/ItemInsurance';
import { Enroll3in1SOP } from './Enroll3in1SOP';
import { api_getRecruitmentContractorInsuranceList, api_setRecruitmentContractorInsuranceList } from '../../../../api/apiRecruitmentContractorInsurance';
import { api_getLaborInsuranceLevel_Arr, api_getHealthInsuranceLevel_Arr } from '../../../../api/apiOpenData';
import Swal from 'sweetalert2';
import { DateOfInsuranceOnboard } from '../../../../item/ItemCustomerPosition';
import { Enroll2in1SOP } from './Enroll2in1SOP';
import { HealthInsuranceEnrollSOP } from './HealthInsuranceEnrollSOP';
import { GroupInsuranceEnrollSOP } from './GroupInsuranceEnrollSOP';

export function ContractorEnrollList({ id, setIsLoading, isEnroll = true }) {
    const [insuranceType, setInsuranceType] = useState(INSURANCE_STATUS_DEFAULT)
    const [tokenId, setTokenId] = useState("")
    const [customerContractId, setCustomerContractId] = useState("")
    const [insuranceList, setInsuranceList] = useState([])
    const [insuranceView, setInsuranceView] = useState("")

    const [overdueCount, setOverdueCount] = useState(0)
    const [todayCount, setTodayCount] = useState(0)

    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [mReqInsuranceList, setReqInsuranceList] = useState({})

    const [laborInsuranceLevel_Arr, setLaborInsuranceLevel_arr] = useState([])
    const [healthInsuranceLevel_Arr, setHealthInsuranceLevel_Arr] = useState([])

    useEffect(() => {
        getLaborInsuranceLevel_Arr()
        getHealthInsuranceLevel_Arr()
    }, [])

    useEffect(() => {
        if (laborInsuranceLevel_Arr.length === 0 || healthInsuranceLevel_Arr.length === 0)
            return
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqInsuranceList = new ReqInsuranceList({})
            if (url === "") {
                toSearch({})
            } else {
                mReqInsuranceList.fromJson(url)
                // console.log(mReqRecruitmentContractorStatusList)
                setReqInsuranceList(mReqInsuranceList)
                toSearch({ items: mReqInsuranceList, page: url.page })
            }
        } else {
            toSearch({})
        }
    }, [id, insuranceType, laborInsuranceLevel_Arr, healthInsuranceLevel_Arr])

    function getLaborInsuranceLevel_Arr() {
        api_getLaborInsuranceLevel_Arr({
            success: (jsonData) => {
                try {
                    var detail = JSON.parse(jsonData.detail.info)
                    setLaborInsuranceLevel_arr(detail)
                    // console.log(detail)
                } catch (error) {
                    console.log(error)
                }
            },
            failure: (err) => {

            }
        })
    }

    function getHealthInsuranceLevel_Arr() {
        api_getHealthInsuranceLevel_Arr({
            success: (jsonData) => {
                //console.log(jsonData)
                var detail = JSON.parse(jsonData.detail.info)
                setHealthInsuranceLevel_Arr(detail)
            },
            failure: (err) => {

            }
        })
    }


    function toSearch({ items, page = 1 }) {
        // console.log(items)
        if(insuranceType ===INSURANCE_STATUS_DEFAULT)
        return
        setInsuranceList([])
        var start = (page - 1) * limit;
        setPage(page)
        var mReqInsuranceList = new ReqInsuranceList({ companyId: getUserInfoCompanyId, insuranceType, start, limit })
        if (items !== undefined)
            mReqInsuranceList.fromJson(items)
        mReqInsuranceList.page = page
        setVal2Token("url", mReqInsuranceList, id)
        setReqInsuranceList(mReqInsuranceList)
        getInsuranceList(mReqInsuranceList)
    }


    function getInsuranceList(mReqInsuranceList) {
        // console.log(mReqInsuranceList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        api_getRecruitmentContractorInsuranceList({
            mReqInsuranceList,
            success: (obj) => {
                // console.log(obj)
                var list = []
                obj.list.map(item => {
                    var mRespInsuranceListItem = new RespInsuranceListItem({ item })
                    var insurance
                    switch (insuranceType) {
                        case INSURANCE_TYPE_ENROLL_3IN1:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: INSURANCE_STATUS_ENROLL,
                                laborInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: INSURANCE_STATUS_ENROLL,
                                healthInsuranceDate: getOnlyDate(),
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_ENROLL_2IN1:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: INSURANCE_STATUS_ENROLL,
                                laborInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: item.healthInsuranceStatus,
                                healthInsuranceDate: item.healthInsuranceDate,
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_ENROLL_HEALTH:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: item.laborInsuranceStatus,
                                laborInsuranceDate: item.laborInsuranceDate,
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: INSURANCE_STATUS_ENROLL,
                                healthInsuranceDate: getOnlyDate(),
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_ENROLL_GROUP:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: item.laborInsuranceStatus,
                                laborInsuranceDate: item.laborInsuranceDate,
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: item.healthInsuranceStatus,
                                healthInsuranceDate: item.healthInsuranceDate,
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: INSURANCE_STATUS_ENROLL,
                                groupInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_CANCEL_3IN1:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: INSURANCE_STATUS_CANCEL,
                                laborInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: INSURANCE_STATUS_CANCEL,
                                healthInsuranceDate: getOnlyDate(),
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_CANCEL_2IN1:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: INSURANCE_STATUS_CANCEL,
                                laborInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: item.healthInsuranceStatus,
                                healthInsuranceDate: item.healthInsuranceDate,
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_CANCEL_HEALTH:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: item.laborInsuranceStatus,
                                laborInsuranceDate: item.laborInsuranceDate,
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: INSURANCE_STATUS_CANCEL,
                                healthInsuranceDate: getOnlyDate(),
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: item.groupInsuranceStatus,
                                groupInsuranceDate: item.groupInsuranceDate,
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        case INSURANCE_TYPE_CANCEL_GROUP:
                            insurance = InsuranceCombinationInitInit({
                                caseContractor: item.caseContractor,
                                insuredUnitGUI: item.insuredUnitGUI,
                                laborInsuranceType: item.laborInsuranceType,
                                laborInsuranceStatus: item.laborInsuranceStatus,
                                laborInsuranceDate: item.laborInsuranceDate,
                                laborInsuranceLevel: item.laborInsuranceLevel,
                                healthInsuranceStatus: item.healthInsuranceStatus,
                                healthInsuranceDate: item.healthInsuranceDate,
                                healthInsuranceLevel: item.healthInsuranceLevel,
                                groupInsuranceGUI: item.groupInsuranceGUI,
                                groupInsuranceStatus: INSURANCE_STATUS_CANCEL,
                                groupInsuranceDate: getOnlyDate(),
                                laborInsuranceLevel_Arr,
                                healthInsuranceLevel_Arr,
                            })
                            break;
                        default:
                            break;
                    }
                    // console.log(insurance)
                    mRespInsuranceListItem.setInsurance(insurance)
                    list.push(mRespInsuranceListItem)
                })
                // console.log(list)
                // console.log('overdueCount' + obj.overdueCount)
                // console.log('todayCount' + obj.todayCount)
                setOverdueCount(obj.overdueCount)
                setTodayCount(obj.todayCount)
                setCount(obj.count)
                setInsuranceList(list)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    useEffect(()=>{
        // console.log("insuranceList改變")
        // console.log(insuranceList)
        if (laborInsuranceLevel_Arr.length === 0 || healthInsuranceLevel_Arr.length === 0) {
            return
        }
        // console.log('overdueCount' + overdueCount)
        // console.log('todayCount' + todayCount)

        switch (insuranceType) {
            case INSURANCE_TYPE_ENROLL_3IN1:
            case INSURANCE_TYPE_CANCEL_3IN1:
                setInsuranceView(<Enroll3in1SOP list={insuranceList}
                    isEnroll={isEnroll}
                    count={count}
                    page={page}
                    sp={toSearch}
                    action={toAction}
                    oc={overdueCount}
                    tc={todayCount}
                    laborInsuranceLevel_Arr={laborInsuranceLevel_Arr}
                    healthInsuranceLevel_Arr={healthInsuranceLevel_Arr} />)
                break;
            case INSURANCE_TYPE_ENROLL_2IN1:
            case INSURANCE_TYPE_CANCEL_2IN1:
                setInsuranceView(<Enroll2in1SOP list={insuranceList}
                    isEnroll={isEnroll}
                    count={count}
                    page={page}
                    sp={toSearch}
                    action={toAction}
                    oc={overdueCount}
                    tc={todayCount}
                    laborInsuranceLevel_Arr={laborInsuranceLevel_Arr}
                    healthInsuranceLevel_Arr={healthInsuranceLevel_Arr} />)
                break;
            case INSURANCE_TYPE_ENROLL_HEALTH:
            case INSURANCE_TYPE_CANCEL_HEALTH:
                setInsuranceView(<HealthInsuranceEnrollSOP list={insuranceList}
                    isEnroll={isEnroll}
                    count={count}
                    page={page}
                    sp={toSearch}
                    action={toAction}
                    oc={overdueCount}
                    tc={todayCount}
                    laborInsuranceLevel_Arr={laborInsuranceLevel_Arr}
                    healthInsuranceLevel_Arr={healthInsuranceLevel_Arr} />)
                break;
            case INSURANCE_TYPE_ENROLL_GROUP:
            case INSURANCE_TYPE_CANCEL_GROUP:
                setInsuranceView(<GroupInsuranceEnrollSOP list={insuranceList}
                    isEnroll={isEnroll}
                    count={count}
                    page={page}
                    sp={toSearch}
                    action={toAction}
                    oc={overdueCount}
                    tc={todayCount}
                    laborInsuranceLevel_Arr={laborInsuranceLevel_Arr}
                    healthInsuranceLevel_Arr={healthInsuranceLevel_Arr} />)
                break;
            default:
                setInsuranceView(<></>)
                break;
        }
    },[insuranceList])

    function toAdd() {
        var tokenId = uuid(128, 64)
        setVal2Token("customerPosition", { customerContractId }, tokenId)
        window.location.assign("/CustomerPositionAdd/" + tokenId);
    }

    function toAction(mReqInsuranceList) {
        // console.log(mReqInsuranceList)
        if (mReqInsuranceList.length === 0) {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '請至少勾選一人',
            })
            return
        }
        setIsLoading(true)
        api_setRecruitmentContractorInsuranceList({
            mReqInsuranceList,
            success: (jsonData) => {
                setIsLoading(false)
                Swal.fire({
                    type: 'success',
                    title: '提醒',
                    text: isEnroll?'完成加保':'完成退保',
                }).then(() => {
                    toSearch({})
                })
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    var content =
        <>
            <div className="row">
                <div className="col-md-12">
                    <SingleSelect title={"請選擇保險作業方式"}
                        val={insuranceType}
                        valType={SELECT_VAL_TYPE_INT}
                        attr={isEnroll ? InsuranceEnrollType_Arr : InsuranceCancelType_Arr}
                        action={setInsuranceType}
                        hasBlank={true}
                        size={4}
                    />
                </div>
            </div>
        </>
    return (
        <>
            <ContentBox content={content} hasTitle={false} hasDrawer={false} />
            {insuranceView}
        </>
    )
}
